module.exports = __webpack_public_path__ + "img/anf5.8db23fda.png";